export default __webpack_public_path__ + "static/media/PsyPackLogo.17adc0c8.svg";